export default __webpack_public_path__ + "static/media/sliderImage1.94713e31.jpg";